import React from 'react'
import './BloodDonationcamp.css';
import bloodimg from './Drop.jpg'
import donation1 from './Donation1.jpg'
import donation2 from './Donation2.jpg'
import donation3 from './Donation3.jpg'


const BloodDonationCamp = () => {
  return (
    <div>
      <div className='blood'>
        <img src={bloodimg} alt='img'></img>
        
      </div>
      <div className='camp'>
        <p> Organized Blood Donation Camp</p>
        <p>In the memory of Hon.Late Vishwasrao Chavan & Hon.Late Avinash V.Chavan.</p>
        </div>
        <div className='donation'>
          <div className='donation-img'>
          <img src={donation1} alt='img'></img>
          <img src={donation2} alt='img'></img>
          <img src={donation3} alt='img'></img>
          </div>
        </div>
    </div>
  )
}

export default BloodDonationCamp;
